export const LOCAL_STORAGE = {
  REDIRECT_URL: 'redirect-route',
  LANGUAGE: 'language'
};
